<template>
  <div class="content-tab poeconfigure">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body title">
      <div class="content-item">
        <div class="content-body-header">{{$t("poe.configTitle")}}</div>
        <div class="content-body-item">
          <div class="dt">
            <div class="dt-r">
              <div class="title dt-c">{{$t('poe.powerSup')}}</div>
              <span class="dynamic-color">{{watt}}</span>
            </div>
          </div>
        </div>
        <div class="content-body-item">
          <div class="title">{{$t('poe.reservePower')}}</div>
          <span :title="$t('poe.consumptionMode')" class="dynamic-color" >{{$t('poe.consumptionMode')}}</span>
          <span class="icon-info info-color ft-14 power-rule" @click="onInfoClick"></span>
        </div>
        <div class="note">
          <icon-remind class="remind"></icon-remind>
          <span class="title">{{$t('poe.boundingNote')}}</span>
        </div>
        <div class="formRow group-table">
          <fixed-table ref="portTable" :data="portLists" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
                <column style="width: 10%;" :title="this.$isOverflow($t('port.portnumber'))" :id="$t('port.portnumber')">{{$t('port.portnumber')}}</column>
                <column style="width: 22.5%;">{{$t('poe.mode')}}
                  <div class="icon-info info-color ft-14 poe-mode" @click="onInfoClick"></div>
                </column>
                <column style="width: 27.5%;">{{$t('poe.legacyMode')}}
                  <div class="icon-info info-color ft-14 legacy" @click="onInfoClick"></div>
                </column>
                <column style="width: 22.5%;;">{{$t('poe.priority')}}
                  <div class="icon-info info-color ft-14 priority" @click="onInfoClick"></div>
                </column>
                <column style="width: 17.5%; margin-right: 5px;" :title="this.$isOverflow($t('poe.powerUse'))" :id="$t('poe.powerUse')">{{$t('poe.powerUse')}}
                </column>
            </div>
            <template slot="rows" slot-scope="props">
              <div class="link-row">
                <row class="right" :props="props" :title="getTips(props.data.key)">
                  <div class="data" style="width: 10%;">{{getPortNum(props.data.key)}}</div>
                  <div class="data" style="width: 22.5%;min-width:180px;text-overflow: initial;">
                    <q-select ref="mode" class="q-select" :props="props.index" :value="props.data.val.Mode" :options-array="(props.index > 17) ? modeOptions : dModeOptions" :rule="props.data.key" @change="onModeChange" :isDisabled="setDisabled(props.data.key) "></q-select></div>
                  <div class="data" style="width: 27.5%;min-width:fit-content;text-overflow: initial;">
                    <q-select class="q-select" :props="props.index" :value="props.data.val.LegacyDetection" :options-array="legacyOptions" :rule="props.data.key" @change="onLegacyChange" :isDisabled="setDisabled(props.data.key)"></q-select></div>
                  <div class="data" style="width: 22.5%;min-width:180px;text-overflow: initial;">
                    <q-select class="q-select" :props="props.index" :value="props.data.val.Priority" :options-array="prioOptions" :rule="props.data.key" @change="onPriChange" :isDisabled="setDisabled(props.data.key)"></q-select></div>
                  <div class="data" style="width: 17.5%;">{{props.data.val.PowerConsumption}}</div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </div>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!saveBtn">{{$t('save')}}</button>
      </div>
    </div>
    <v-dialog/>
    <!-- <info v-show="isShow" ref="infoTips" :message=message :onChange="onInfoClick" :styleObject="styleObj"/> -->
    <popup-confirm name="watt-warning-modal" :dialog-header="$t('warning')" :dialog-message="warningMsg" icon="w" :onlyOk="true"></popup-confirm>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import config from '../config'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import Radio from './module/Radio'
import qSelect from './module/Select.vue'
import info from './module/InfoTips'
import iconRemind from '../assets/svg/ic_system_remind.svg'
export default {
  name: 'PoeConfiguration',
  components: {
    config,
    fixedTable,
    row,
    column,
    Radio,
    info,
    qSelect,
    iconRemind
  },
  filters: {
    getPD: function (pdclass) {
      let result = '--'
      if (pdclass !== -1) {
        result = pdclass
      }
      return result
    }
  },
  data () {
    return {
      portLists: [],
      classType: this.$t('poe.class'),
      allocationType: this.$t('poe.allocation'),
      consumptionMode: this.$t('poe.consumptionMode'),
      reservedMode: this.$t('poe.reserveMode'),
      watt: 280,
      selType: '',
      selMode: '',
      priority: '',
      warningMsg: '',
      selectIndex: -1,
      isAll: true,
      radioItems: ['class', 'allocated'],
      ruleRadioItems: ['Consumption', 'ReservedPower'],
      isPriorityDisable: false,
      isMaxPowerDisable: false,
      showBt: false,
      isShow: false,
      message: [],
      saveBtn: false,
      isTableResize: false,
      isShowLoading: false,
      styleObj: {},
      prioOptions: [
        {label: '--', value: 'none', rule: 'all'},
        { value: 'critical', label: 'poe.critical' },
        { value: 'high', label: 'poe.high' },
        { value: 'low', label: 'poe.low' }
      ],
      legacyOptions: [
        { value: false, label: 'port.disabled' },
        { value: true, label: 'port.enabled' }
      ],
      modeOptions: [
        {label: '--', value: 'none', rule: 'all'},
        { value: 'disable', label: 'poe.disableMode' },
        { value: 'poeDot3af', label: 'poe.poeMode' },
        { value: 'poePlusDot3bt', label: 'poe.plusMode' }
      ],
      dModeOptions: [
        {label: '--', value: 'none', rule: 'all'},
        { value: 'disable', label: 'poe.disableMode' },
        { value: 'poeDot3af', label: 'poe.poeMode' },
        { value: 'poePlusDot3at', label: 'poe.plusMode' },
        // { value: 'upoe', label: 'poe.uPoeMode' },
        { value: 'poePlusDot3bt', label: 'poe.dPlusMode' }
      ],
      perPortInterval: null,
      originalData: null
    }
  },
  created: async function () {
    this.getConfig()
  },
  beforeDestroy () {
    clearInterval(this.perPortInterval)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('updateInfoTips', false)
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    saveBtn: function (value) {
      this.$store.commit('updateDataChanged', value)
    },
    lang: {
      handler (value) {
        let me = this
        setTimeout(() => {
          me.$forceUpdate()
        }, 500)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      isDataChanged: state => state.app.isDataChanged
    })
  },
  methods: {
    getConfig: function () {
      let me = this
      clearInterval(this.perPortInterval)
      this.isShowLoading = true
      this.saveBtn = false
      this.axios.all([this.getPoeGlobal(), this.getPoePortConfig(), this.getPoeStatus()])
        .then(this.axios.spread(function (global, config, status) {
          me.watt = global.data.result.MaxPower
          me.portLists = config.data.result
          me.originalData = JSON.parse(JSON.stringify(me.portLists))
          status.data.result.forEach((element, index) => {
            me.portLists[index].val.PDClass = element.val.PDClass
            me.portLists[index].val.PowerConsumption = element.val.PowerConsumption / 10
            me.originalData[index].val.PDClass = element.val.PDClass
            me.originalData[index].val.PowerConsumption = element.val.PowerConsumption / 10
          })
          me.isShowLoading = false
        }))
      this.perPortInterval = setInterval(() => {
        me.getPoeStatus()
          .then((res) => {
            let portResult = this.portLists
            if (!res.data.error) {
              res.data.result.forEach((element, index) => {
                portResult[index].val.PDClass = element.val.PDClass
                portResult[index].val.PowerConsumption = element.val.PowerConsumption / 10
              })
              me.portLists = portResult
              me.$forceUpdate()
            }
          })
      }, 6000)
      // } catch (err) {
      //   this.$log.error(err)
      // }
    },
    getPortNum: function (name) {
      if (name === 'all') {
        this.isAll = true
        return name
      } else {
        this.all = false
        return name
      }
    },
    setAllocateWatt: function (mode) {
      if (mode === 'poeDot3af') {
        return 15.4
      } else {
        return 30
      }
    },
    onModeChange: function (value, index) {
      this.portLists[index].val.Mode = value
      this.setSaveBtn()
      setTimeout(() => {
        this.onBlur(index)
      }, 50)
    },
    onPriChange: function (value, index) {
      this.portLists[index].val.Priority = value
      this.onBlur(index)
    },
    onLegacyChange: function (value, index) {
      this.portLists[index].val.LegacyDetection = value
      this.onBlur(index)
    },
    checkChangedItem: function () {
      let data = []
      this.portLists.forEach((element, index) => {
        if (element.key !== this.$t('all')) {
          if (element.val.Mode !== this.originalData[index].val.Mode) {
            data.push(element)
          } else if (element.val.Priority !== this.originalData[index].val.Priority) {
            data.push(element)
          } else if (element.val.LegacyDetection !== this.originalData[index].val.LegacyDetection) {
            data.push(element)
          }
        }
      })
      return data
    },
    onSaveClick: function () {
      this.$log.debug(this.portLists, this.watt)
      this.isShowLoading = true
      let me = this
      let changedItem = this.checkChangedItem()
      me.setPoePortConfig(changedItem).then(res => {
        me.getConfig()
      })
    },
    onInfoClick: function (event) {
      this.message = []
      this.styleObj = {}
      this.isShow = !this.isShow
      this.$store.commit('updateInfoTips', this.isShow)
      if (this.isShow) {
        let className = event.currentTarget.className
        if (className.indexOf('management-mode') > -1) {
          this.message.push(this.$t('poe.manageModeInfoTitle1'))
          this.message.push(this.$t('poe.manageModeInfo1'))
          this.message.push(this.$t('poe.manageModeInfoTitle2'))
          this.message.push(this.$t('poe.manageModeInfo2'))
        } else if (className.indexOf('power-rule') > -1) {
          this.message.push({text: this.$t('poe.ruleInfoTitle3')})
        } else if (className.indexOf('poe-mode') > -1) {
          this.message.push({text: this.$t('poe.poeModeInfo1')})
          this.message.push({text: this.$t('poe.poeModeInfo2', '1', '8', 'PoE++')})
          // this.message.push({text: this.$t('poe.poeModeInfo3')})
          this.message.push({text: this.$t('poe.poeModeInfo4')})
          this.message.push({text: this.$t('poe.poeModeInfo5')})
          // this.message.push({text: this.$t('poe.poeModeInfo6')})
          this.message.push({text: this.$t('poe.poeModeInfo7')})
        } else if (className.indexOf('priority') > -1) {
          this.message.push({text: this.$t('poe.priorityInfo1')})
          // this.message.push({text: this.$t('poe.priorityInfo2')})
        } else if (className.indexOf('pd-require') > -1) {
          this.message.push(this.$t('poe.requireInfo'))
        } else if (className.indexOf('max-power') > -1) {
          this.message.push(this.$t('poe.powerInfo'))
        } else if (className.indexOf('legacy') > -1) {
          this.message.push({text: this.$t('poe.legacyTip')})
        }
        this.styleObj['top'] = event.clientY - 115 + 'px'
        if (document.body.clientWidth - event.clientX < 310) {
          this.styleObj['right'] = '5px'
        } else {
          this.styleObj['left'] = event.clientX - 270 + 'px'
        }
        this.$store.commit('updateInfoData', {
          message: this.message,
          event: event
        })
      }
    },
    setSaveBtn: function () {
      let me = this
      let temp = false
      me.portLists.forEach((element, index) => {
        if (!me.$compareObj(element.val, me.originalData[index].val)) {
          temp = true
        }
      })
      me.saveBtn = temp
    },
    onBlur: function (idx) {
      this.selectIndex = idx
      this.setSaveBtn()
    },
    checkValidation: function () {
      let me = this
      this.$validator.validateAll().then((result) => {
        this.saveBtn = result
        if (result && this.isTableResize) {
          this.$refs.groupTable.style.height = this.$refs.groupTable.offsetHeight + 20 + 'px'
          this.isTableResize = false
        }
        if (me.errors.has('maxpower' + me.selectIndex)) {
          if (this.portLists[me.selectIndex].val.Mode === 'poeDot3af') {
            this.warningMsg = this.$t('errorMessage.poeLimit')
          } else if (this.portLists[me.selectIndex].val.Mode === 'poePlusDot3at') {
            this.warningMsg = this.$t('errorMessage.poePlusLimit')
          }
          this.openModal('watt-warning-modal')
          this.$modal.show('watt-warning-modal')
        }
      })
    },
    setErrorMessage: function (data) {
      let message = ''
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else {
          message = this.$t('errorMessage.poeRange')
        }
        if (!this.isTableResize) {
          this.$refs.groupTable.style.height = this.$refs.groupTable.offsetHeight - 20 + 'px'
          this.isTableResize = true
        }
      }
      return message
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault()
      }
    },
    setDisabled: function (key) {
      if (key > 8) return true
      return false
    },
    getTips: function (key) {
      let tips = ''
      if (this.setDisabled(key)) {
        tips = this.$t('poe.notSup')
      }
      return tips
    },
    ...mapActions(['getPoeGlobal', 'getPoePortConfig', 'getPoeStatus', 'setPoePortConfig']),
    ...mapMutations(['openModal', 'closeModal'])
  }
}
</script>

<style lang="scss" scoped>

.content-tab.poeconfigure {
  height: 100%;
  position: relative;
  padding: 20px 15px;
    .content-body {
      height: 100%;
      .content-item {
        position: relative;
        height: calc(100% - 40px);
        div.content-body-header {
          padding: 0px 0px 10px 20px;
        }
        .content-body-item {
          padding-left: 20px !important;
          margin-bottom: 10px;
          margin-left: 30px;
          .title {
            display: inline-block;
          }
          .power-watt {
            width: 78px;
          }
          .q-radio {
            margin-left: 20px;
          }
        }
      }
      .group-table {
        margin-right: 15px;
        height: calc(100% - 140px);
        min-width: 800px;
      }
      >.content-body-footer {
        top: calc(100% - 50px);
      }
      .power {
        width: 100px;
        vertical-align: middle;
      }
      .q-select .display-label {
        font-size: 13px;
        color: #000;
      }
      .q-select {
        width: 160px;
        height: 30px;
        border: 1px solid #979797 !important;
        border-radius: 4px;
        vertical-align: middle;
        /deep/ .dropdown-menu {
          left: -1px;
          width: 160px;
          height: auto;
          overflow: auto;
        }
        /deep/ .display-label {
          font-size: 13px !important;
          color: #2F2F2F !important;
          line-height: 30px !important;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        &::after {
          background-color: #000;
          top: -25px;
        }
    }
  }
}
.note {
  font-family: 'Roboto-R';
  font-size: 14px;
  color: #195A87;
  text-align: left;
  line-height: 18px;
  margin: 10px 0px 20px 0px;
  svg {
    vertical-align: top;
  }
  .remind {
    width: 16px;
    height: 18px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PoeConfiguration.vue